import { render, staticRenderFns } from "./RichMenuImageEditor.vue?vue&type=template&id=12a37ec9&scoped=true&"
import script from "./RichMenuImageEditor.vue?vue&type=script&lang=js&"
export * from "./RichMenuImageEditor.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuImageEditor.vue?vue&type=style&index=0&id=12a37ec9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a37ec9",
  null
  
)

export default component.exports